export * from "./types.js";
export * from "./copy.js";
export {
  cgtOnSale,
  lossApplicationOrder,
  washSaleFlag,
  daysHeldExclusive,
  fullCostBase,
  reducedCostBase,
  assertNoFinancialProductHandoff,
  CgtHandoffError,
} from "./calculate.js";
export { fy2025_26 } from "./fy2025-26.js";

import type { FinancialYear } from "../types.js";
import type { CgtRuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";

/** Registry of CGT rulesets by financial year. Historical years stay registered
 * so re-runs / amendments (a prior-year CGT amendment resolves against the rules
 * — and the marginal scale — in force then). */
export const CGT_RULESETS: Record<string, CgtRuleSet> = {
  "2025-26": fy2025_26,
};

/** Resolve the CGT ruleset for a financial year, or throw if unknown. */
export function cgtRulesFor(fy: FinancialYear): CgtRuleSet {
  const rules = CGT_RULESETS[fy];
  if (!rules) {
    throw new Error(`no CGT ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent CGT ruleset — the default for live "this year" calcs. */
export const CGT_CURRENT_FY: FinancialYear = "2025-26";
